import { c as _c } from "react/compiler-runtime";
import { LayoutContainer, Picture } from '@petsmart-ui/sparky';
import cn from 'classnames';
import Link from 'next/link';
import { ContentfulClick } from '@libs/analytics';
import { HeaderCtaTracker } from '../../../utils/HeaderCtaTracker';
import { propsImageItems } from '../../../utils/propsImagesItems';
import { Text } from '../../Text';
import type { CampaignCarsUpProps } from '../types';
import './info.scss';
export function CampaignCardsInfo(t0) {
  const $ = _c(27);
  const {
    header,
    body,
    backgroundFill,
    textLink,
    textLinkColor,
    cardsTextColor,
    cards,
    textColor
  } = t0;
  let t1;
  if ($[0] !== backgroundFill) {
    t1 = {
      background: backgroundFill
    };
    $[0] = backgroundFill;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== header || $[3] !== textColor) {
    t2 = <Text color={textColor} as="h2">{header}</Text>;
    $[2] = header;
    $[3] = textColor;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== body || $[6] !== textColor) {
    t3 = <Text align="center" color={textColor}>{body}</Text>;
    $[5] = body;
    $[6] = textColor;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== header || $[9] !== textLink || $[10] !== textLinkColor) {
    t4 = textLink && <HeaderCtaTracker textLink={textLink} linkTextColor={textLinkColor} header={header ?? ""} promoVariant="campaign cards up - info" promoType="campaign-cards-info__card" />;
    $[8] = header;
    $[9] = textLink;
    $[10] = textLinkColor;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== t2 || $[13] !== t3 || $[14] !== t4) {
    t5 = <div className="campaign-cards-info__header">{t2}{t3}{t4}</div>;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== cards || $[17] !== cardsTextColor || $[18] !== header || $[19] !== textLink?.link?.webUrl) {
    t6 = cards?.map((card, index) => {
      const imageItems = propsImageItems(card.image);
      const linkUrl = card?.link?.webUrl || textLink?.link?.webUrl || "";
      const Component = linkUrl ? Link : "div";
      return <ContentfulClick component={Component} key={card.sysId} className="campaign-cards-info__card" style={{
        background: card.backgroundFill
      }} href={linkUrl} eventData={{
        position: index + 1,
        linkText: cn(card.header, card.body),
        linkUrl,
        promoTitle: header ?? "",
        promoVariant: "campaign cards up - info",
        promoDesc: card.internalTitle,
        promoType: "campaign-cards-info__card"
      }} prefetch={false}><Picture imgSrc={imageItems[0]?.srcSet} imgAlt={card.image.webAltText} items={imageItems} /><div><Text color={cardsTextColor} className="campaign-cards-info__card-title">{card.header}</Text><Text color={cardsTextColor}>{card.body}</Text></div></ContentfulClick>;
    });
    $[16] = cards;
    $[17] = cardsTextColor;
    $[18] = header;
    $[19] = textLink?.link?.webUrl;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  let t7;
  if ($[21] !== t6) {
    t7 = <div className="campaign-cards-info__cards">{t6}</div>;
    $[21] = t6;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  let t8;
  if ($[23] !== t1 || $[24] !== t5 || $[25] !== t7) {
    t8 = <LayoutContainer className="campaign-cards-info"><div className="campaign-cards-info__content" style={t1}>{t5}{t7}</div></LayoutContainer>;
    $[23] = t1;
    $[24] = t5;
    $[25] = t7;
    $[26] = t8;
  } else {
    t8 = $[26];
  }
  return t8;
}